'use client'

import { useId } from 'react'

/**
 * Genera ids estables y consistentes para un campo de formulario y su mensaje
 * (helper/error), para asociarlos por `aria-describedby`. Reutilizable por
 * cualquier campo del DS (TextField, MultiSelectField, TextArea…).
 */
export function useFieldIds(providedId?: string): { fieldId: string; messageId: string } {
  const generated = useId()
  const fieldId = providedId ?? generated
  return { fieldId, messageId: `${fieldId}-message` }
}
